import { render, staticRenderFns } from "./bank-details.vue?vue&type=template&id=388042ab&"
import script from "./bank-details.vue?vue&type=script&lang=js&"
export * from "./bank-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports